import { Component, Input } from '@angular/core';

@Component({
  selector: 'pop-settings-box',
  templateUrl: './settings-box.component.html',
  styleUrls: ['./settings-box.component.less']
})
export class SettingsBoxComponent {
  @Input() public labelKey: string;
  @Input() public vertical = false;
}
